import { ScannerMeasurementAreaGraphDomains } from '@/types/types';

export const SCAN_FETCH_DEBOUNCE_RATE = 500;
/**
 * A field holding an invalid value (below its `min`) is not saved on the normal
 * debounce. It waits this much longer, so a pause mid-number does not get the
 * value silently clamped and written back under the operator's caret.
 */
export const SCAN_FETCH_INVALID_DEBOUNCE_RATE = 2000;
export const GLOBAL_STORE_NAME = 'global-store';
export const INSPECTION_STORE_NAME = 'inspection-store';
export const INSPECTION_CONFIGURATION_TEMPLATE_TAG = 'template';
export const INSPECTION_CONFIGURATION_CUSTOM_TAG = 'custom';
export const WORK_ORDER_STORE_NAME = 'work-order-store';
export const INSPECTION_BANNER_STORE_NAME = 'inspection-banner-store';
export const INSPECTION_PAGINATION_STORE_NAME = 'inspection-pagination-store';

export const NONE = 'none';
export const NOT_DEFINED = 'not_defined';
export const FACE_SIDE_FACE = 'face'; //converts to boolean upon clicking "save" on Add/Edit Inspection Configuration page
export const FACE_SIDE_ROOT = 'root';

export const JOINT_TYPE_T_JOINT = 't_joint';
export const JOINT_TYPE_BUTT_JOINT = 'butt_joint';
export const JOINT_TYPE_LAP_JOINT = 'lap_joint';
export const JOINT_TYPE_CORNER_JOINT = 'corner_joint';
export const JOINT_TYPE_EDGE_JOINT = 'edge_joint';
export const JOINT_TYPE_ANGLE_JOINT = 'angle_joint';

export const WELD_TYPE_BUTT = 'butt';
export const WELD_TYPE_FILLET = 'fillet';

export const MEASUREMENT_TYPE_STANDARD = 'standard';
export const MEASUREMENT_TYPE_POOR_RESTART = 'poor';

export const INSPECTION_TYPE_OBJECT_JOINT = 'joint';
export const INSPECTION_TYPE_OBJECT_WELD = 'weld';
export const INSPECTION_TYPE_OBJECT_GEOMETRY = 'geometry';
export const INSPECTION_TYPE_OBJECT_BENDING = 'bending';

export const FILLET_TYPE_LEG = 'leg';
export const FILLET_TYPE_THROAT = 'throat';

export const PLATE_GEOMETRY_LINEAR = 'linear';
export const PLATE_GEOMETRY_CONVEX = 'convex';
export const PLATE_GEOMETRY_CONCAVE = 'concave';

// export const POST_WELD_TREATMENT_NOT_DEFINED = 'not_defined';
export const POST_WELD_TREATMENT_NONE = 'none';
export const POST_WELD_TREATMENT_HFMI = 'hfmi';
export const POST_WELD_TREATMENT_TIG = 'tig_dressing';
export const POST_WELD_TREATMENT_BURR = 'burr_grinding';

// export const PLATE_SURFACE_CONDITION_NOT_DEFINED = 'not_defined';
export const PLATE_SURFACE_CONDITION_POLISHED = 'polished';
export const PLATE_SURFACE_CONDITION_SMOOTH = 'smooth';
export const PLATE_SURFACE_CONDITION_ROUGH = 'rough';
export const PLATE_SURFACE_CONDITION_VERY_ROUGH = 'very_rough';

export const SCANNER_MEASUREMENT_AREAS: Record<
  string,
  ScannerMeasurementAreaGraphDomains
> = {
  ['Gocator 2520']: {
    x: [-33, 33],
    y: [40, 80]
  },
  ['scanCONTROL 3000-25 /BL']: {
    x: [-15, 15],
    y: [72, 97]
  }
};

export const INSPECTION_TYPE_OPTIONS = [
  {
    label: 'Weld',
    value: INSPECTION_TYPE_OBJECT_WELD
  },
  {
    label: 'Geometry',
    value: INSPECTION_TYPE_OBJECT_GEOMETRY
  },
  {
    label: 'Joint (analysis unavailable)',
    value: INSPECTION_TYPE_OBJECT_JOINT
  },
  {
    label: 'Bending (analysis unavailable)',
    value: INSPECTION_TYPE_OBJECT_BENDING
  }
];

export const MEASUREMENT_TYPE_OPTIONS = [
  {
    label: 'Standard',
    value: MEASUREMENT_TYPE_STANDARD
  },
  {
    label: 'Poor restart (analysis unavailable)',
    value: MEASUREMENT_TYPE_POOR_RESTART
  }
];

export const FACE_SIDE_OPTIONS = [
  {
    label: 'Face Side',
    value: FACE_SIDE_FACE
  },
  {
    label: 'Root Side',
    value: FACE_SIDE_ROOT
  }
];
export const JOINT_TYPE_OPTIONS = [
  {
    label: 'Butt Joint',
    value: JOINT_TYPE_BUTT_JOINT
  },
  {
    label: 'T-Joint',
    value: JOINT_TYPE_T_JOINT
  },
  // {
  //   label: 'Single Plate',
  //   value: 'Single Plate'
  // },
  {
    label: 'Lap Joint (analysis unavailable)',
    value: JOINT_TYPE_LAP_JOINT
  }
];
export const WELD_TYPE_OPTIONS = [
  {
    label: 'Fillet Weld',
    value: WELD_TYPE_FILLET
  },
  {
    label: 'Butt Weld',
    value: WELD_TYPE_BUTT
  }
  // {
  //   label: 'Single Plate',
  //   value: 'Single Plate'
  // }
];
export const FILLET_TYPE_OPTIONS = [
  {
    label: 'Throat',
    value: FILLET_TYPE_THROAT
  },
  {
    label: 'Leg',
    value: FILLET_TYPE_LEG
  }
];
export const PLATE_GEOMETRY_OPTIONS = [
  {
    label: 'Linear',
    value: PLATE_GEOMETRY_LINEAR
  },
  {
    label: 'Convex',
    value: PLATE_GEOMETRY_CONVEX
  },
  {
    label: 'Concave',
    value: PLATE_GEOMETRY_CONCAVE
  }
];

export const POST_WELD_TREATMENT_OPTIONS = [
  {
    label: 'Not Defined',
    value: NOT_DEFINED
  },
  {
    label: 'None',
    value: NONE
  },
  {
    label: 'HFMI',
    value: POST_WELD_TREATMENT_HFMI
  },
  {
    label: 'Tig Dressing',
    value: POST_WELD_TREATMENT_TIG
  },
  {
    label: 'Burr Grinding',
    value: POST_WELD_TREATMENT_BURR
  }
];

//Currently not in use.
export const PLATE_SURFACE_CONDITION_OPTIONS = [
  {
    label: 'Not Defined',
    value: NOT_DEFINED
  },
  {
    label: 'Polished',
    value: PLATE_SURFACE_CONDITION_POLISHED
  },
  {
    label: 'Smooth',
    value: PLATE_SURFACE_CONDITION_SMOOTH
  },
  {
    label: 'Rough',
    value: PLATE_SURFACE_CONDITION_ROUGH
  },
  {
    label: 'Very Rough',
    value: PLATE_SURFACE_CONDITION_VERY_ROUGH
  }
];

export const ACCEPTED_DATA_QUALITY_OPTIONS = [
  {
    label: 'Manual Configuration',
    value: 'Manual Configuration'
  },
  {
    label: 'General Inspection',
    value: 'General Inspection'
  },
  {
    label: 'Detailed Inspection',
    value: 'Detailed Inspection'
  }
];

export const CAST_OPTIONS = [
  {
    label: 'No',
    value: 'no'
  },
  {
    label: 'Yes',
    value: 'yes'
  }
];
export const PLATE_ANGLE_DEVIATION_OPTIONS = [
  {
    label: '± 5°',
    value: '5'
  },
  {
    label: '± 10°',
    value: '10'
  },
  {
    label: '± 15°',
    value: '15'
  },
  {
    label: '± 20°',
    value: '20'
  }
];

// export const ANALYSIS_SCOPE_OPTIONS = [
//   {
//     label: 'Full Analysis',
//     value: INSPECTION_CONFIGURATION_ANALYSIS_SCOPE.FULL
//   },
//   {
//     label: 'Trimmed Analysis (faster)',
//     value: INSPECTION_CONFIGURATION_ANALYSIS_SCOPE.RELEVANT_ONLY
//   },
//   {
//     label: 'Only Summary Results (fastest)',
//     value: INSPECTION_CONFIGURATION_ANALYSIS_SCOPE.RELEVANT_ONLY_NO_VISUALS
//   }
// ];

/* ---------------------------------------------- ADD/EDIT INSPECTION CONFIGURATION /EDIT INSPECTION FORM VALIDATION ARRAYS -------------------------------------- */
export const BUTT_JOINT_VALIDATION_ELEMENTS = [
  'inspection_object_type',
  'joint_type',
  'measurement_type',
  'face_side',
  'weld_type',
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'nominal_butt_weld_thickness',
  'quality_standard',
  'quality_level',
  'incomplete_acceptance',
  'incomplete_max_length',
  'result_density',
  'plate_geometry_left',
  'plate_geometry_right',
  'plate_length_left',
  'plate_length_right',
  'plate_surface_condition_left',
  'plate_surface_condition_right',
  'post_weld_treatment_left',
  'post_weld_treatment_right',
  'nominal_plate_angle',
  'nominal_plate_angle_deviation',
  'cast'
];
export const NUMERIC_INSPECTION_CONFIGURATION_FIELDS = [
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'leg_length_left_min',
  'leg_length_left_max',
  'leg_length_right_min',
  'leg_length_right_max',
  'incomplete_acceptance',
  'incomplete_max_length',
  'nominal_butt_weld_thickness',
  'nominal_throat_thickness',
  'result_density',
  'plate_length_left',
  'plate_length_right',
  'nominal_plate_angle',
  'nominal_plate_angle_deviation'
];
export const T_JOINT_FILLET_LEG_VALIDATION_ELEMENTS = [
  'description',
  'inspection_object_type',
  'joint_type',
  'measurement_type',
  'face_side',
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'weld_type',
  'fillet_type',

  'leg_length_left_min',
  'leg_length_left_max',
  'leg_length_right_min',
  'leg_length_right_max',
  'quality_standard',
  'quality_level',
  'incomplete_acceptance',
  'incomplete_max_length',
  'result_density',
  'plate_geometry_left',
  'plate_geometry_right',
  'plate_surface_condition_left',
  'plate_surface_condition_right',
  'plate_length_left',
  'plate_length_right',
  'post_weld_treatment_left',
  'post_weld_treatment_right',
  'nominal_plate_angle',
  'nominal_plate_angle_deviation',

  'cast'
];
export const T_JOINT_FILLET_THROAT_VALIDATION_ELEMENTS = [
  'description',
  'inspection_object_type',
  'joint_type',
  'measurement_type',
  'face_side',
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'weld_type',
  'fillet_type',
  'nominal_throat_thickness',
  'quality_standard',
  'quality_level',
  'incomplete_acceptance',
  'incomplete_max_length',
  'result_density',
  'plate_geometry_left',
  'plate_geometry_right',
  'plate_surface_condition_left',
  'plate_surface_condition_right',
  'plate_length_left',
  'plate_length_right',
  'post_weld_treatment_left',
  'post_weld_treatment_right',
  'nominal_plate_angle',
  'nominal_plate_angle_deviation',
  'cast'
];

export const T_JOINT_WITHOUT_FILLET_TYPE_VALIDATION_ELEMENTS = [
  'description',
  'inspection_object_type',
  'joint_type',
  'measurement_type',
  'weld_side',
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'weld_type',
  'fillet_type',
  'quality_standard',
  'quality_level',
  'incomplete_acceptance',
  'incomplete_max_length',
  'result_density',
  'plate_geometry_left',
  'plate_geometry_right',
  'plate_surface_condition_left',
  'plate_surface_condition_right',
  'plate_length_left',
  'plate_length_right',
  'post_weld_treatment_left',
  'post_weld_treatment_right',
  'cast'
];
export const EDIT_INSPECTION_INSPEC_VALIDATION_ELEMENTS = [
  'Inspection_Comment',
  'Inspection_Description',
  'Inspection__Project Name',
  'Inspection__Sample ID',
  'Inspection__Weld ID',
  'Inspection__Test Series'
];
export const FIELDS_TO_SANITIZE = [
  'nominal_butt_weld_thickness',
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'nominal_throat_thickness',
  'leg_length_left_min',
  'leg_length_left_max',
  'leg_length_right_min',
  'leg_length_right_max',
  'incomplete_acceptance',
  'incomplete_max_length',
  'result_density',
  'plate_geometry_left',
  'plate_geometry_right',
  // 'plate_length_left',
  // 'plate_length_right',
  'plate_surface_condition_left',
  'plate_surface_condition_right',
  'post_weld_treatment_left',
  'post_weld_treatment_right',
  'nominal_plate_angle',
  'nominal_plate_angle_deviation',
  'cast'
];
export const NUMERIC_FIELDS_LIST = [
  'nominal_butt_weld_thickness',
  'nominal_plate_thickness_left',
  'nominal_plate_thickness_right',
  'nominal_throat_thickness',
  'leg_length_left_min',
  'leg_length_left_max',
  'leg_length_right_min',
  'leg_length_right_max',
  'incomplete_acceptance',
  'incomplete_max_length',
  'result_density',
  'plate_length_left',
  'plate_length_right',
  'nominal_plate_angle'
];
/* ---------------------------------------------- ADD INSPECTION CONFIGURATION FORM VALIDATION ARRAYS END -------------------------------------- */

export const QUALITY_ASSESSMENT_ANALYSIS_LEVELS = [
  {
    analysis_level: 'Manual Configuration',
    incomplete_acceptance: '',
    incomplete_max_length: '',
    result_density: ''
  },
  {
    analysis_level: 'General Inspection',
    incomplete_acceptance: Number(15.0).toFixed(2),
    incomplete_max_length: Number(5.0).toFixed(2),
    result_density: Number(1.0).toFixed(2)
  },
  {
    analysis_level: 'Detailed Inspection',
    incomplete_acceptance: Number(10.0).toFixed(2),
    incomplete_max_length: Number(1.0).toFixed(2),
    result_density: Number(5.0).toFixed(2)
  }
];
